import * as helpers from "./helpers"

class QuizService {
    get helpers(){
        return helpers
    }
}

export default QuizService